module.exports = __webpack_public_path__ + "img/103.4a5f3361.jpg";